﻿export class Correo {
    idCorreo: number = 0;
    direccion: string = "";
    contrasena: string = "";
    servidor: string = "";
    puerto: string = "";
    usaSSL: boolean = false;
}